import LoadingOrderClient from "../../../api/loading-order";
import { toast } from "react-toastify";

const storage = () => localStorage.getItem('selectedOperation');
const _filteredOCsHasDocument = String(localStorage.getItem('filteredOCsHasDocument')) === 'true'

const storageAssignOnValidate = () => {
  const storage = localStorage.getItem('selectedAssignOnValidade')
  return storage ? JSON.parse(storage) : [{ value: 'all', label: 'Todas' }]
}

const storageAssignOnAdd = () => {
  const storage = localStorage.getItem('selectedAssignOnAdd')
  return storage ? JSON.parse(storage) : [{ value: 'all', label: 'Todas' }]
}

const storageFilterOcReseted = () => {
  const storage = localStorage.getItem('selectedOCResetedFilter')
  return storage ? JSON.parse(storage) : { value: 'all', label: 'Todas' }
}

export const loadingOrders = {
  state: {
    filterState: [],
    filteredOperation: [],
    filteredOCsHasDocument: _filteredOCsHasDocument,
    filteredOCsHasDocumentPersist: _filteredOCsHasDocument,
    filterAssignOnValidate: storageAssignOnValidate(),
    filterAssignUserOnValidate: storageAssignOnValidate(),
    filterAssignOnAdd: storageAssignOnAdd(),
    filterAssignUserOnAdd: storageAssignOnAdd(),
    filterOcReseted: storageFilterOcReseted(),
    filterOCResetedPersist: storageFilterOcReseted(),
  },
  reducers: {
    setFilteredOCsHasDocument(state, { filteredOCsHasDocument, persist = false }) {
      let filteredOCsHasDocumentPersist = state.filteredOCsHasDocumentPersist
      if (persist) {
        localStorage.setItem('filteredOCsHasDocument', filteredOCsHasDocument)
        filteredOCsHasDocumentPersist = filteredOCsHasDocument
      }
      return {
        ...state,
        filteredOCsHasDocument,
        filteredOCsHasDocumentPersist
      };
    },
    setFiltered(state, payload) {
      return {
        ...state,
        filterState: payload,
      };
    },
    setFilteredOperation(state, payload) {
      localStorage.setItem('selectedOperation', JSON.stringify(payload));

      return {
        ...state,
        filteredOperation: payload,
      };
    },
    setAssignFilterOnValidate(state, payload) {
      let data = []

      if (payload) {
        data = payload
      } else if (payload === null) {
        data = []
      } else {
        data = storageAssignOnValidate()
      }

      return {
        ...state,
        filterAssignOnValidate: data
      }
    },
    setAssignOnValidate(state, payload) {
      localStorage.setItem('selectedAssignOnValidade', JSON.stringify(payload))

      return {
        ...state,
        filterAssignUserOnValidate: payload
      }
    },
    setAssignFilterOnAdd(state, payload) {
      let data = []

      if (payload) {
        data = payload
      } else if (payload === null) {
        data = []
      } else {
        data = storageAssignOnValidate()
      }

      return {
        ...state,
        filterAssignOnAdd: data
      }
    },
    setAssignOnAdd(state, payload) {
      localStorage.setItem('selectedAssignOnAdd', JSON.stringify(payload))

      return {
        ...state,
        filterAssignUserOnAdd: payload
      }
    },
    setFilterOcReseted(state, payload) {
      let data = {}

      if (payload) {
        data = payload
      } else if (payload === null) {
        data = { value: 'all', label: 'Todas' }
      } else {
        data = storageFilterOcReseted()
      }

      return {
        ...state,
        filterOcReseted: data
      }
    },
    setFilterOcResetedOnLocalStorage(state, payload) {
      localStorage.setItem('selectedOCResetedFilter', JSON.stringify(payload))

      return {
        ...state,
        filterOCResetedPersist: payload
      }
    }
  },
  effects: (dispatch) => ({
    loadFiltered() {
      const filteredOperation = storage();
      if (filteredOperation) {
        const data = JSON.parse(filteredOperation);
        this.setFiltered(data);
        this.setFilteredOperation(data);
      }
    },
    async loadSelected() {
      const filteredOperation = await storage();
      if (filteredOperation) {
        this.setFilteredOperation(JSON.parse(filteredOperation));
      }
    },
    async clearAsync(payload, rootState) {
      await LoadingOrderClient.clear(payload.id, payload.reason);
      return true;
    },
    async resetOCNumberAsync(payload, rootState) {
      try {
        await LoadingOrderClient.resetOCDocument(payload);
      } catch (error) {
        toast.error("Ops :( Algo deu errado !");
      }
      return true;
    },
    async setAssignOnValidateAsync(payload) {
      if (payload) {
        if (payload.length === 0) {
          this.setAssignFilterOnValidate([{ value: 'all', label: 'Todas' }])
        }
        this.setAssignOnValidate(payload)
      } else {
        this.setAssignOnValidate(storageAssignOnValidate())
      }
    },
    async setAssignOnAddAsync(payload) {
      if (payload) {
        if (payload.length === 0) {
          this.setAssignFilterOnAdd([{ value: 'all', label: 'Todas' }])
        }
        this.setAssignOnAdd(payload)
      } else {
        this.setAssignOnAdd(storageAssignOnAdd())
      }
    },
    async setFilterOcResetedAsync(payload) {
      if (payload) {
        this.setFilterOcResetedOnLocalStorage(payload)
      } else {
        this.setFilterOcResetedOnLocalStorage(storageFilterOcReseted())
      }
    }
  }),
};
